<template>
  <a-card title="短信营销" :headStyle="{borderBottom:'0px',fontSize:'18px'}">
    <a-row>
      <a-col :span="14" class="border-box">
        <a-card title="场景营销" :bordered="false" :bodyStyle="{padding:'5px'}"
                :headStyle="{borderBottom:'0px',fontSize: '16px' }">
          <div class="box-flex">
            <a-card v-for="(item,index) in sceneList" :key="index" class="card-style" :title="item.title"
                    :bodyStyle="{padding:'10px'}"
                    :headStyle="{padding:'0px 10px',fontSize: '14px',fontWeight: 'bold' }">
              <a slot="extra" @click="onJumpPage(item.value)">{{ item.link }}</a>
              <div class="card-content">{{ item.content }}</div>
            </a-card>
            <a-card class="card-style" title="付款提醒"
                    :bodyStyle="{padding:'10px'}"
                    :headStyle="{padding:'0px 10px',fontSize: '14px',fontWeight: 'bold' }">
              <a v-if="orderRemind==0" slot="extra" @click="onJumpPage(3)">立即开启</a>
              <a v-else slot="extra" @click="onJumpPage(3,true)" class="red">立即关闭</a>
              <div class="card-content">促进订单成交，提升转化率。</div>
            </a-card>
            <a-card class="card-style" title="收藏提醒"
                    :bodyStyle="{padding:'10px'}"
                    :headStyle="{padding:'0px 10px',fontSize: '14px',fontWeight: 'bold' }">
              <a v-if="collectRemind==0" slot="extra" @click="onJumpPage(4)">立即开启</a>
              <a v-else slot="extra" @click="onJumpPage(4,true)" class="red">立即关闭</a>
              <div class="card-content">提醒近30天收藏过任一商品的用户尽快购买，提升转化率。</div>
            </a-card>
            <a-card class="card-style" title="爆款商品提醒"
                    :bodyStyle="{padding:'10px'}"
                    :headStyle="{padding:'0px 10px',fontSize: '14px',fontWeight: 'bold' }">
              <a v-if="hotProRemind==0" slot="extra" @click="onJumpPage(5)">立即开启</a>
              <a v-else slot="extra" @click="onJumpPage(5,true)" class="red">立即关闭</a>
              <div class="card-content">单商品当日成交超过一定订单量，引导用户下单。</div>
            </a-card>
            <a-card class="card-style" title="生日祝福"
                    :bodyStyle="{padding:'10px'}"
                    :headStyle="{padding:'0px 10px',fontSize: '14px',fontWeight: 'bold' }">
              <a v-if="birthdayRemind==0" slot="extra" @click="onJumpPage(6)">立即开启</a>
              <a v-else slot="extra" @click="onJumpPage(6,true)" class="red">立即关闭</a>
              <div class="card-content">开启生日提醒，提供更好的客户关怀服务。</div>
            </a-card>
            <a-card class="card-style" title="商品降价提醒"
                    :bodyStyle="{padding:'10px'}"
                    :headStyle="{padding:'0px 10px',fontSize: '14px',fontWeight: 'bold' }">
              <a v-if="proPriceReduceRemind==0" slot="extra" @click="onJumpPage(7)">立即开启</a>
              <a v-else slot="extra" @click="onJumpPage(7)" class="red">立即关闭</a>
              <div class="card-content">商品降价达到一定幅度，提醒用户下单，转化率极高。</div>
            </a-card>
            <a-card class="card-style" title="直播短信提醒"
                    :bodyStyle="{padding:'10px'}"
                    :headStyle="{padding:'0px 10px',fontSize: '14px',fontWeight: 'bold' }">
              <a v-if="liveRemind==0" slot="extra" @click="onJumpPage(8)">立即开启</a>
              <a v-else slot="extra" @click="onJumpPage(8,true)" class="red">立即关闭</a>
              <div class="card-content">开播时自动短信通知，迅速引爆直播间热度。</div>
            </a-card>
          </div>
        </a-card>
      </a-col>
      <a-col :span="9" class="border-box" style="margin-left: 30px;">
        <a-card title="短信账户" :bordered="false" :bodyStyle="{padding:'0 20px'}"
                :headStyle="{padding:'0 20px',borderBottom:'0px',fontSize: '16px' }">
          <a slot="extra" @click="goSmsOrder">购买记录</a>
          <a-card title="短信余量" :bordered="false" :bodyStyle="{padding:'20px 0'}"
                  :headStyle="{color:'rgba(0, 0, 0, 0.447058823529412)',padding:'3px 0',fontSize: '14px' }">
            <span class="top-num" slot="extra">{{ smsNumber }} <span>条</span></span>
            <div class="card-box">
              <div class="box-title">购买短信</div>
              <div class="unit-price">
                <div class="unit-text">单价</div>
                <div class="sms-price">{{ unitPrice }} 元/条</div>
                <div class="unit-text">远低于市场价格</div>
              </div>
              <div class="price-list">
                <div class="price-box" @click="changeSmsBox(item)" :class="{selectedActive:item.money == rechargeMoney}"
                     v-for="(item,index) in smsList" :key="index">
                  <div class="box-left">
                    <div class="sms-num">{{ item.smsNum }} <span>条</span></div>
                    <div class="add-num">加赠{{ item.addNum }}条</div>
                  </div>
                  <div class="sms-amount"><span>￥</span>{{ item.money }}</div>
                </div>
              </div>
              <div style="display: flex;justify-content: center">
                <!-- <a-button type="primary" style="width: 90%;" @click="onRecharge">立即购买</a-button> -->
              </div>
            </div>
          </a-card>
        </a-card>
      </a-col>
    </a-row>
    <a-modal
      :visible="visible"
      :closable="false"
      width="500px"
      :footer="null"
    >
      <div class="modal-top">
        <img src="../../../assets/warming-icon.jpg" alt="">
        <div style="margin-left: 10px">开启后，若符合条件将自动发送以下内容</div>
      </div>
      <a-form style="margin-bottom: 50px;">
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          label="短信内容"
        >
          <a-textarea disabled v-model="smsText" :rows="3"/>
        </a-form-item>
      </a-form>
      <div class="bottom-button">
        <a-button @click="handleCancel">取消</a-button>
        <a-button type="primary" style="margin-left: 20px" @click="confirm">确认开启</a-button>
      </div>
    </a-modal>
    <a-modal title="微信支付" :footer="null" :visible="rechargeVisible" @cancel="handleRechargeCancel">
      <a-radio-group v-model="payType">
        <a-radio v-for="(item,index) in payTypeList" :key="index" :value="item.id">{{ item.payWay }}</a-radio>
      </a-radio-group>
      <div v-if="payType" style="margin: 0 auto;border: 1px solid #444444;width: 202px;margin-top:20px;">
        <img :src="erWeiMaImageSrc" style="width: 200px;height: 200px;">
        <div style="text-align: center;width: 200px;">{{ getPayName(payType) }}扫一扫，完成支付</div>
      </div>
    </a-modal>
  </a-card>
</template>

<script>
export default {
  name: 'SmsMarketing',
  data() {
    return {
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 8 }
      },
      sceneList: [
        {
          title: '自定义手机号发送',
          link: '立即创建',
          content: '导入私有人群手机号，定向高效营销。',
          value: 0
        },
        {
          title: '人群发送',
          link: '立即创建',
          content: '按用户标签或分销员分组发送，人群定向发送，提升转化率。',
          value: 1
        },
        {
          title: '新客转化',
          link: '立即创建',
          content: '促进新访客转化，为平台带来新生意。',
          value: 2
        }
      ],
      smsList: [],
      unitPrice: 0.064,
      rechargeMoney: 100,
      visible: false,
      merchantId: this.$store.getters.userInfo.merchantId,
      orderRemind: 0,//订单提醒
      collectRemind: 0,//收藏提醒
      hotProRemind: 0,//商品提醒
      proPriceReduceRemind: 0,//降价提醒
      birthdayRemind: 0,//生日提醒
      liveRemind: 0,//直播提醒
      id: undefined,
      smsNumber: 0,
      options: [],
      payType: 1,
      payTypeList: {},
      rechargeVisible: false,
      erWeiMaImageSrc: '',
      openType: 3,
      rechargeNo: '',
      smsText: '【签名】温馨提醒，您的订单尚未付款，为确保心仪的商品/服务早日启程、顺利抵达，记得尽早付款哦~如有疑问请咨询客服，祝生活愉快！'
    }
  },
  mounted() {
    this.getSmsRemindSet()
    this.getSmsNumber()
    this.getSysPrice()
    this.getPayTypeInfo()
  },
  watch: {
    rechargeVisible(val) {
      if (!val) {
        this.rechargeNo = ''
      }
    }
  },
  methods: {
    handleRechargeCancel() {
      this.rechargeVisible = false
    },
    //获取短信条数
    getSmsNumber() {
      this.getHttpServices().getSmsApiService().post('sms/getSmsNumber', {
        merchantId: this.merchantId,
        platformId: this.getPlatformConfig().platformId
      }).then(res => {
        this.smsNumber = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getPayName: function(type) {
      const list = this.payTypeList
      if (list) {
        for (let i = 0, len = list.length; i < len; i++) {
          if (type == list[i].id) {
            return list[i].payWay
          }
        }
      }
      return ''
    },
    //获取短信价格
    getSysPrice() {
      this.getHttpServices().getSmsApiService().post('base/sms/getSysPrice')
        .then(res => {
          this.smsList = res
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getSmsRemindSet() {
      this.getHttpServices().getUserService().get('user/sys/getSmsRemindSet?merchantId=' + this.merchantId)
        .then(res => {
          this.orderRemind = res.orderRemind ? res.orderRemind : 0
          this.collectRemind = res.collectRemind ? res.collectRemind : 0
          this.hotProRemind = res.hotProRemind ? res.hotProRemind : 0
          this.orderRemind = res.orderRemind ? res.orderRemind : 0
          this.birthdayRemind = res.birthdayRemind ? res.birthdayRemind : 0
          this.liveRemind = res.liveRemind ? res.liveRemind : 0
          this.id = res.id ? res.id : undefined
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleOk(value) {
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    },
    confirm() {
      this.saveSmsRemindSet(this.openType)
    },
    changeSmsBox(item) {
      this.unitPrice = item.price
      this.rechargeMoney = item.money
    },
    saveSmsRemindSet(type, closeType) {
      let param = {
        merchantId: this.merchantId,
        proPriceReduceRemind: this.proPriceReduceRemind,
        collectRemind: this.collectRemind,
        hotProRemind: this.hotProRemind,
        birthdayRemind: this.birthdayRemind,
        orderRemind: this.orderRemind,
        liveRemind: this.liveRemind
      }
      if (this.id) {
        param.id = this.id
      }
      if (type == 4) {
        param.collectRemind = this.collectRemind == 1 ? 0 : 1
      } else if (type == 5) {
        param.hotProRemind = this.hotProRemind == 1 ? 0 : 1
      } else if (type == 6) {
        param.birthdayRemind = this.birthdayRemind == 1 ? 0 : 1
      } else if (type == 3) {
        param.orderRemind = this.orderRemind == 1 ? 0 : 1
      } else if (type == 8) {
        param.liveRemind = this.liveRemind == 1 ? 0 : 1
      }
      // console.error('saveSmsRemindSet', param)
      this.getHttpServices().getUserService().post('/user/sys/saveSmsRemindSet', param)
        .then(res => {
          this.getSmsRemindSet()
          this.handleCancel()
          if (closeType) {
            this.$message.success('成功关闭')
          }
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onRecharge() {
      this.rechargeVisible = true
      this.createRechargeSmsNumOrder(this.payType)
    },
    //获取支付类型
    getPayTypeInfo() {
      this.getHttpServices().getSmsApiService().post('base/sms/getPayWay')
        .then(res => {
          this.payTypeList = res
          this.getLogUtils().logWithTag('支付类型', res)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    createRechargeSmsNumOrder(type) {
      if (!type) {
        return
      }
      this.getHttpServices().getSmsApiService().post('base/sms/CreateRechargeSmsNumOrder', {
        merchantId: this.merchantId,
        platformId: this.getPlatformConfig().platformId,
        money: this.rechargeMoney,
        payType: this.payType
      }).then(res => {
        this.rechargeNo = res
        this.getPayImage(res)
        this.rechargeSmsNumIsOk(res)
        this.getLogUtils().logWithTag('获取支付订单号-------------', res)
      }).catch(err => {
        this.getLogUtils().logWithTag('错误', err)
      })
    },
    // 图片示例
    rechargeSmsNumIsOk(rechargeNo) {
      if (!rechargeNo) {
        return
      }
      let url = 'base/sms/rechargeSmsNumIsOk/' + rechargeNo
      this.getHttpServices().getSmsApiService().post(url)
        .then(res => {
          if (res === 1) {
            this.erWeiMaImageSrc = ''
            this.$message.success('充值成功')
            // this.getSmsNumber();
            this.rechargeVisible = false
            this.rechargeNo = null
          } else {
            setTimeout(() => {
              this.rechargeSmsNumIsOk(this.rechargeNo)
            }, 1000)
          }
        }).catch(err => {
        this.getLogUtils().logWithTag(err)
      })
    },
    //获取支付二维码图片
    getPayImage(orderId) {
      let url = '/base/sms/rechargeSmsNUM?orderCode=' + orderId
      this.erWeiMaImageSrc = this.getAppConfig().smsUrl + url
    },
    goSmsOrder() {
      this.$router.push({
        name: 'SmsOrderList'
      })
    },
    changeSmsContent(openType) {
      if (openType == 3) {
        this.smsText = '【签名】温馨提醒，您的订单尚未付款，为确保心仪的商品/服务早日启程、顺利抵达，记得尽早付款哦~如有疑问请咨询客服，祝生活愉快！'
      } else if (openType == 4) {
        this.smsText = '【签名】温馨提醒，您收藏的商品「某某酒店299抢...」即将售罄，记得尽早下单哦~如有疑问请咨询客服，祝生活愉快！'
      } else if (openType == 5) {
        this.smsText = '【签名】温馨提醒，您浏览过的商品「某某酒店299抢...」已升级为爆款。即将售罄！欲购从速！记得尽早下单哦~如有疑问请咨询客服，祝生活愉快！'
      } else if (openType == 6) {
        this.smsText = '【签名】尊敬的{姓名}，今天是您的生日，感谢您长久以来对我们的关心与支持，在这美好的日子里，愿所有的快乐、所有的好运围绕在您身边。祝您生日快乐、事事如意！'
      } else if (openType == 8) {
        this.smsText = '【签名】温馨提醒，小程序直播间「直播标题」开播啦，爆款折扣商品直播限时抢购，速来观看哦~如有疑问请咨询客服，祝生活愉快！'
      }
    },
    onJumpPage(value, close) {
      if (value < 3) {
        this.openNewPage('SendSmsMsg', {
          type: value
        })
      } else if (value == 7) {
        this.$message.error('暂未上线')
      } else {
        this.openType = value
        this.changeSmsContent(value)
        if (close) {
          this.saveSmsRemindSet(this.openType, close)
        } else {
          this.handleOk(value)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.border-box {
  border: 1px solid rgba(233, 233, 233, 1);
}

.box-flex {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.card-style {
  width: 31%;
  margin-bottom: 20px;
}

.card-content {
  color: rgba(0, 0, 0, 0.447058823529412);
  font-size: 14px;
}

.top-num {
  font-size: 16px;
  font-weight: bold;

  span {
    font-size: 14px;
    font-weight: 400;
  }
}

.card-box {
  position: relative;

  .box-title {
    font-size: 16px;
    line-height: 18px;
    margin-bottom: 20px;
    height: 18px;
    padding-left: 10px;
    border-left: 1px solid cornflowerblue;
  }

  .unit-price {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .unit-text {
      color: rgba(0, 0, 0, 0.447058823529412);
      font-size: 14px;
    }

    .sms-price {
      margin: 0 10px;
      color: #FF7700;
      font-size: 14px;
    }
  }

  .price-list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .price-box {
      width: 48%;
      height: 80px;
      border: 1px solid rgba(240, 242, 245, 1);
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 10px;
      margin-bottom: 20px;

      .box-left {
        .sms-num {
          font-size: 16px;
          margin-bottom: 5px;

          span {
            font-size: 12px;
          }
        }

        .add-num {
          color: #FF7700;
          font-size: 12px;
        }
      }

      .sms-amount {
        span {
          font-size: 12px;
        }

        color: #FF7700;
        font-size: 18px;
      }
    }
  }
}

.selectedActive {
  width: 200px;
  height: 80px;
  border: 1px solid #FF7700 !important;
}

.modal-top {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.bottom-button {
  position: absolute;
  right: 25px;
  bottom: 20px;
}

.red {
  color: red;
}
</style>
